// eslint-disable-next-line import/prefer-default-export
export const enableComponents = (context, settings, components) => {
  Object.values(components).forEach(({ enable }) => enable(context, settings));
};
